// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"816":"ff4d4011","961":"dd8f59d6"}[chunkId] + ".css";
};